// Sócrates — la cara única de la IA de Academia Alpha.
// Internamente delega en subagentes especialistas, uno por materia (Agentes Alpha).
// `key` coincide con el slug del curso; `backendKey` es la clave que acepta hoy /api/mentor/chat.

export const SOCRATES = {
  key: "socratico",
  backendKey: "socratico",
  name: "Sócrates",
  role: "El corazón pedagógico de Academia Alpha. Un mentor IA entrenado en mayéutica clásica y pedagogía crítica contemporánea.",
  intro:
    "Bienvenido. No estoy aquí para darte respuestas: estoy aquí para preguntarte mejor. Cuéntame en qué estás pensando, qué te confunde o qué idea te ronda estos días.",
  accent: "Mayéutica · Diálogo · Autonomía",
  prompts: [
    "¿Qué es realmente pensar?",
    "¿Por qué me cuesta concentrarme en textos largos?",
    "Discúteme la existencia del libre albedrío",
  ],
};

// Subagentes especialistas por materia (uno por curso).
//
// `mentor` es el NOMBRE PROPIO del personaje —Hipatia, Max, Ariadna, Ulises, Lira— y `name`
// es cómo se le llama en la cabecera del chat, «Alpha · Literatura». Son dos cosas y hacen
// falta las dos: la cabecera dice de qué materia va, y el carrusel dice quién es.
//
// `caracter` es su TONO —cómo habla—, y también lo dice el backend. Es lo que se lee en gris
// en la tarjeta de la portada: a distintos alumnos les funcionan distintos adultos, y eso es
// una decisión pedagógica de la casa, no un adorno. La lista larga —registro, para_quien,
// ejemplos— se queda donde está; aquí sólo cruza la línea que se enseña.
//
// LOS NOMBRES SE ESCRIBIERON EN EL BACKEND y no cruzaron. El rótulo del cuarto decía
// «LITERATURA ESTÁ TRABAJANDO» porque aquí sólo había la materia. Es la cuarta duplicación
// que cruza de idioma, así que la vigila `tools/check_contratos.py` como las otras tres: la
// verdad la dice `backend/app/domain/mentores.py`.
export const ALPHA_AGENTS = [
  {
    key: "filosofia",
    backendKey: "filosofia",
    // Su nombre propio. El del catálogo del backend.
    mentor: "Hipatia",
    name: "Alpha · Filosofía",
    role: "Especialista IA en filosofía occidental clásica, moderna y contemporánea",
    accent: "Ética · Metafísica · Fenomenología",
    // Su CARACTER, palabra por palabra como lo dice `backend/app/domain/mentores.py`
    // en su campo `tono`. Lo vigila `tools/check_contratos.py`: es la quinta cosa
    // que vive en los dos lados, y las cuatro anteriores cruzaron mal.
    caracter: "Seca e implacable, pero tranquila. Exige y no adula.",
  },
  {
    key: "literatura",
    backendKey: "literatura",
    // Su nombre propio. El del catálogo del backend.
    mentor: "Max",
    name: "Alpha · Literatura",
    role: "Especialista IA en teoría, historia y crítica literaria",
    accent: "Narrativa · Voz · Forma",
    // Su CARACTER, palabra por palabra como lo dice `backend/app/domain/mentores.py`
    // en su campo `tono`. Lo vigila `tools/check_contratos.py`: es la quinta cosa
    // que vive en los dos lados, y las cuatro anteriores cruzaron mal.
    caracter: "Gracioso, chulo, listo. Se lo pasa bien y se le nota.",
  },
  {
    key: "psicologia",
    backendKey: "psicologia",
    // Su nombre propio. El del catálogo del backend.
    mentor: "Ariadna",
    name: "Alpha · Psicología",
    role: "Especialista IA en psicología: memoria, hábitos, desarrollo y orientación",
    accent: "Memoria · Hábitos · Decisiones",
    // Su CARACTER, palabra por palabra como lo dice `backend/app/domain/mentores.py`
    // en su campo `tono`. Lo vigila `tools/check_contratos.py`: es la quinta cosa
    // que vive en los dos lados, y las cuatro anteriores cruzaron mal.
    caracter: "Cercana, clara y asertiva. Firme sin dureza.",
  },
  {
    key: "cultura-clasica",
    backendKey: "cultura-clasica",
    // Su nombre propio. El del catálogo del backend.
    mentor: "Ulises",
    name: "Alpha · Cultura Clásica",
    role: "Especialista IA en el mundo grecolatino: mito, historia, arte y legado",
    accent: "Mito · Polis · Legado",
    // Su CARACTER, palabra por palabra como lo dice `backend/app/domain/mentores.py`
    // en su campo `tono`. Lo vigila `tools/check_contratos.py`: es la quinta cosa
    // que vive en los dos lados, y las cuatro anteriores cruzaron mal.
    caracter: "Dramático, épico, grandilocuente. Todo es una gesta.",
  },
  {
    key: "musica",
    backendKey: "musica",
    // Su nombre propio. El del catálogo del backend.
    mentor: "Lira",
    name: "Alpha · Música",
    role: "Especialista IA en historia, análisis y estética musical",
    accent: "Armonía · Forma · Estética",
    // Su CARACTER, palabra por palabra como lo dice `backend/app/domain/mentores.py`
    // en su campo `tono`. Lo vigila `tools/check_contratos.py`: es la quinta cosa
    // que vive en los dos lados, y las cuatro anteriores cruzaron mal.
    caracter: "Eufórica, motivadora, con la energía de quien celebra cada acierto.",
  },
];

// El nombre corto de cada miembro de la familia, para la cabecera de un chat.
//
// Estaba escrito IGUAL en `LessonChat.jsx` y en `SocratesChat.jsx`, con el mismo comentario
// encima. Vive aquí porque es lo que este fichero sabe: quiénes son y cómo se llaman.
export const NOMBRE_DE_AGENTE = Object.fromEntries(
  [SOCRATES, ...ALPHA_AGENTS].map((a) => [a.key, a.name])
);

// Y SU NOMBRE PROPIO, que es el que va al lado de la cara: Hipatia, no «Alpha · Filosofía».
export const NOMBRE_DEL_MENTOR = Object.fromEntries(
  [SOCRATES, ...ALPHA_AGENTS].map((a) => [a.key, a.mentor || a.name])
);

